import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CallsComponent } from './calls/calls.component'
import { LoginComponent } from './login/login.component'
import { AuthGuard } from './shared/auth/AuthGuard'
import { HmRestrictionGuard } from './shared/auth/HmRestrictionGuard'
import { CampaignSelectorComponent } from './campaign-selector/campaign-selector.component'
import { LandingComponent } from './landing/landing.component'
import { CustomRoutes } from './shared/models/Routing'
import { ApplicationArea } from './shared/services/ppv.api'
import { EmployeeTypeMapComponent } from './employee-type-map/employee-type-map.component'
import { EscheatmentComponent } from './escheatment/escheatment.component'
import { PaymentGroupMapComponent } from './payment-group-map/payment-group-map.component'
import { ProductsListComponent } from './products/products-list/products-list.component'
import { DoctorScheduleComponent } from './doctor-schedule/doctor-schedule.component'
import { ProductsLandingComponent } from './products/products-landing/products-landing.component'
import { ProductsVcListComponent } from './products/products-vc-list/products-vc-list.component'
import { ProductsAdminListComponent } from './products/products-admin-list/products-admin-list.component'
import { VetcorPricingLandingComponent } from './vetcor-pricing/vetcor-pricing-landing/vetcor-pricing-landing.component'
import { VetcorPricingAdminComponent } from './vetcor-pricing/vetcor-pricing-admin/vetcor-pricing-admin.component'
import { VetcorPricingAdminRequestsComponent } from './vetcor-pricing/vetcor-pricing-admin-requests/vetcor-pricing-admin-requests.component'
import { DVMToolDashboardComponent } from './dvm-tool/dvm-tool-dashboard/dvm-tool-dashboard.component'
import { DVMToolPlanComponent } from './dvm-tool/dvm-tool-plan/dvm-tool-plan.component'
import { BreadcrumbResolver } from './dvm-tool/breadcrumb.resolver'
import { EntraSyncAppComponent } from './entra-sync/entra-sync-app.component'
import { GrowthToolkitLandingComponent } from './growth-toolkit/components/landing-page/landing-page.component'
import { GrowthToolkitRegionalManagerSummaryPage } from './growth-toolkit/components/regional-manager-summary-page/regional-manager-summary-page.component'
import { GrowthToolkitRegionalManagerHospitalPage } from './growth-toolkit/components/regional-manager-hospital-page/regional-manager-hospital-page.component'
import { GrowthToolkitHospitalManagerDashboardPage } from './growth-toolkit/components/hospital-manager-dashboard-page/hospital-manager-dashboard-page.component'
import { GrowthToolkitDirectorSummaryPage } from './growth-toolkit/components/director-summary-page/director-summary-page.component'
import { ReportPocComponent } from './growth-toolkit/components/report-poc/report-poc.component'
import { LeaderboardComponent } from './leaderboard/leaderboard.component'
import { MentoringAgreementComponent } from './mentoring-agreement/mentoring-agreement.component'
import { MessagingAppComponent } from './messaging/messaging-app.component'
import { HospitalPricingComponent } from './vetcor-pricing/hospital-pricing/hospital-pricing.component'
import { VetcorPricingAdminHospitalComponent } from './vetcor-pricing/vetcor-pricing-admin-hospital/vetcor-pricing-admin-hospital.component'
import { RoleManagerComponent } from './role-manager/role-manager.component'
import { LeaderToolkitDashboardPage } from './leader-toolkit/pages/dashboard/dashboard-page.component'
import { LeaderToolkitGoalsPage } from './leader-toolkit/pages/goals/goals-page.component'
import { LeaderToolkitTasksPage } from './leader-toolkit/pages/tasks/tasks-page.component'
import { LeaderToolkitSchedulingPage } from './leader-toolkit/pages/scheduling/scheduling-page.component'
import { OPSDashboardComponent } from './leader-toolkit/pages/dashboard/ops-dashboard/ops-dashboard.component'
import { HospitalDashboardComponent } from './leader-toolkit/pages/dashboard/hospital-dashboard/hospital-dashboard.component'
import { HospitalEditorComponent } from './leader-toolkit/pages/dashboard/hospital-editor/hospital-editor.component'
import { HospitalOpsDashboardComponent } from './leader-toolkit/pages/dashboard/hospital-ops-dashboard/hospital-ops-dashboard.component'
import { UploadCsvComponent } from './leader-toolkit/pages/upload-csv/upload-csv.component'
import { LeaderGoalToolkitDetailsComponent } from './leader-toolkit/pages/goals/leader-goal-toolkit-details/leader-goal-toolkit-details.component'
import { UserManagementComponent } from './leader-toolkit/pages/user-management/user-management.component'
import { SearchResultsPageComponent } from './leader-toolkit/pages/search/search-results-page.component'


const routes: CustomRoutes = [
   { path: 'login', component: LoginComponent, data: { areaName: 'Auth' } },
   {
      path: '',
      component: LandingComponent,
      canActivate: [AuthGuard],
      data: { areaName: '' },
   },

   {
      path: 'tail-o-phone',
      canActivate: [AuthGuard],
      data: { areaName: 'Tail-O-Phone', breadcrumb: 'Tail-O-Phone' },
      children: [
         {
            path: '',
            component: CampaignSelectorComponent,
            data: { breadcrumb: '' },
         },
         {
            path: 'calls/:campaignId',
            component: CallsComponent,
            data: { breadcrumb: '' },
         },
         {
            path: 'hospital/:practiceId/calls/:campaignId',
            component: CallsComponent,
            data: { breadcrumb: '' },
         },
      ],
   },

   {
      path: 'employee-type-mapper',
      component: EmployeeTypeMapComponent,
      canActivate: [AuthGuard],
      data: {
         areaName: 'Employee Map',
         breadcrumb: 'Employee Map',
         requiredRole: {
            application: ApplicationArea.EmployeeTypeMap,
         },
      },
   },

   {
      path: 'escheatment',
      component: EscheatmentComponent,
      canActivate: [AuthGuard],
      data: {
         areaName: 'Escheatment App',
         breadcrumb: 'Escheatment App',
         requiredRole: {
            application: ApplicationArea.Inventory,
         },
      },
   },

   {
      path: 'products',
      canActivate: [AuthGuard],
      children: [
         {
            path: '',
            component: ProductsLandingComponent,
            data: {
               breadcrumb: 'Home',
            },
         },
         {
            path: 'hospital',
            component: ProductsListComponent,
            data: {
               breadcrumb: 'By Practice',
            },
         },
         {
            path: 'hospital/:practiceSKey',
            component: ProductsListComponent,
            data: {
               breadcrumb: 'By Practice',
            },
         },
         {
            path: 'standard',
            component: ProductsVcListComponent,
            data: {
               breadcrumb: 'By Vetcor Product',
               requiredRole: {
                  application: ApplicationArea.Products,
                  roleName: ['VCProduct'],
               },
            },
         },
         {
            path: 'standard/:vcProductSKey',
            component: ProductsVcListComponent,
            data: {
               breadcrumb: 'By Vetcor Product',
               requiredRole: {
                  application: ApplicationArea.Products,
                  roleName: ['VCProduct'],
               },
            },
         },
         {
            path: 'admin',
            component: ProductsAdminListComponent,
            data: {
               breadcrumb: 'Admin',
               requiredRole: {
                  application: ApplicationArea.Products,
                  roleName: ['VCProduct'],
               },
            },
         },
         {
            path: 'admin/:vcProductSKey',
            component: ProductsAdminListComponent,
            data: {
               breadcrumb: 'Admin',
               requiredRole: {
                  application: ApplicationArea.Products,
                  roleName: ['VCProduct'],
               },
            },
         },
      ],
      data: {
         areaName: 'Service and Products Mapper',
         breadcrumb: 'Service and Products Mapper  ',
         requiredRole: {
            application: ApplicationArea.Products,
         },
      },
   },

   {
      path: 'payment-group-map',
      component: PaymentGroupMapComponent,
      canActivate: [AuthGuard],
      data: {
         areaName: 'Payment Group Map',
         breadcrumb: 'Payment Group Map',
         requiredRole: {
            application: ApplicationArea.PaymentGroupMap,
         },
      },
   },

   {
      path: 'schedule-template',
      component: DoctorScheduleComponent,
      canActivate: [AuthGuard],
      data: {
         areaName: 'Schedule Template',
         breadcrumb: 'Schedule Template',
         requiredRole: {
            application: ApplicationArea.DoctorSchedule,
         },
      },
   },

   {
      path: 'fax-manager',
      canActivate: [AuthGuard],
      data: {
         areaName: 'Fax Manager',
         breadcrumb: 'Fax Manager',
         requiredRole: {
            application: ApplicationArea.FaxManager,
         },
      },
      loadChildren: () => import('./fax-manager/fax-manager.module').then((m) => m.FaxManagerModule),
   },

   {
      path: 'vetcor-pricing',
      canActivate: [AuthGuard],
      children: [
         {
            path: '',
            component: VetcorPricingLandingComponent,
            data: {
               breadcrumb: 'Home',
            },
         },
         // {
         //    path: 'vetcor-pricing-manager',
         //    data: {
         //       breadcrumb: 'Hospital Pricing',
         //    },
         //    children: [
         //       {
         //          path: '',
         //          component: VetcorPricingManagerComponent,
         //          data: {
         //             breadcrumb: '',
         //          },
         //       },
         //       {
         //          path: ':practiceSKey',
         //          component: VetcorPricingManagerComponent,
         //          data: {
         //             breadcrumb: 'Review',
         //          },
         //       },
         //    ],
         // },
         {
            path: 'admin',
            data: {
               breadcrumb: 'Admin',
               requiredRole: {
                  application: ApplicationArea.PricingManager,
                  roleName: ['PricingManagerCaptain'],
               },
            },
            children: [
               {
                  path: '',
                  component: VetcorPricingAdminComponent,
                  data: {
                     breadcrumb: '',
                  },
               },
               {
                  path: ':practiceSKey',
                  component: VetcorPricingAdminHospitalComponent,
                  data: {
                     breadcrumb: 'Review',
                     requiredRole: {
                        application: ApplicationArea.PricingManager,
                        roleName: ['PricingManagerCaptain'],
                     },
                  },
               },
            ],
         },
         {
            path: 'admin-requests',
            data: {
               breadcrumb: 'Admin Requests',
               requiredRole: {
                  application: ApplicationArea.PricingManager,
                  roleName: ['PricingManagerAdmin'],
               },
            },
            children: [
               {
                  path: '',
                  component: VetcorPricingAdminRequestsComponent,
                  data: {
                     breadcrumb: '',
                  },
               },
            ],
         },
         {
            path: 'hospital-pricing',
            data: {
               breadcrumb: 'Hospital Pricing',
               requiredRole: {
                  application: ApplicationArea.PricingManager,
                  roleName: ['PricingManager'],
               },
            },
            children: [
               {
                  path: '',
                  component: HospitalPricingComponent,
                  data: {
                     breadcrumb: '',
                  },
               },
               {
                  path: ':practiceSKey',
                  component: HospitalPricingComponent,
                  data: {
                     breadcrumb: 'Pricing',
                  },
               },
            ],
         },
      ],
      data: {
         areaName: 'Pricing Manager',
         breadcrumb: 'Pricing Manager',
         requiredRole: {
            application: ApplicationArea.PricingManager,
         },
      },
   },

   {
      path: 'dvm-engagement',
      canActivate: [AuthGuard],
      data: {
         areaName: 'DVM Engagement',
         breadcrumb: 'DVM Engagement',
         requiredRole: {
            application: ApplicationArea.DVMTool,
         },
      },
      children: [
         {
            path: '',
            component: DVMToolDashboardComponent,
            data: {
               breadcrumb: 'Dashboard',
            },
         },
         {
            path: ':dvmId',
            component: DVMToolPlanComponent,
            resolve: { breadcrumb: BreadcrumbResolver },
         },
      ],
   },

   {
      path: 'entra-sync',
      component: EntraSyncAppComponent,
      canActivate: [AuthGuard],
      data: {
         areaName: 'Entra Sync',
         breadcrumb: 'Entra Sync',
         requiredRole: {
            application: ApplicationArea.EntraSync,
         },
      },
   },

   {
      path: 'growth-toolkit',
      canActivate: [AuthGuard],
      data: {
         areaName: 'Hospital Growth Toolkit',
         breadcrumb: 'Growth Toolkit',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
      children: [
         {
            path: '',
            component: GrowthToolkitLandingComponent,
            data: {
               breadcrumb: 'Home',
            },
         },

         {
            path: 'regional-manager-summary',
            data: {
               breadcrumb: 'Regional Manager Summary',
            },
            children: [
               {
                  path: '',
                  component: GrowthToolkitRegionalManagerSummaryPage,
                  data: {
                     breadcrumb: '',
                     requiredRole: {
                        application: ApplicationArea.GrowthToolkit,
                        roleName: ['GrowthToolkit'],
                     },
                  },
               },
               {
                  path: ':practiceSKey',
                  component: GrowthToolkitRegionalManagerHospitalPage,
                  data: {
                     breadcrumb: 'Hospital',
                     requiredRole: {
                        application: ApplicationArea.GrowthToolkit,
                        roleName: ['GrowthToolkit'],
                     },
                  },
               },
            ],
         },

         {
            path: 'hospital-manager-dashboard',
            data: {
               breadcrumb: 'Hospital Manager Dashboard',
            },
            children: [
               {
                  path: '',
                  component: GrowthToolkitHospitalManagerDashboardPage,
                  data: {
                     breadcrumb: '',
                     requiredRole: {
                        application: ApplicationArea.GrowthToolkit,
                        roleName: ['GrowthToolkit'],
                     },
                  },
               },
               {
                  path: ':practiceSKey',
                  component: GrowthToolkitHospitalManagerDashboardPage,
                  data: {
                     breadcrumb: 'Hospital',
                     requiredRole: {
                        application: ApplicationArea.GrowthToolkit,
                        roleName: ['GrowthToolkit'],
                     },
                  },
               },
            ],
         },

         {
            path: 'director-summary',
            data: {
               breadcrumb: 'Director View',
            },
            children: [
               {
                  path: '',
                  component: GrowthToolkitDirectorSummaryPage,
                  data: {
                     breadcrumb: '',
                     requiredRole: {
                        application: ApplicationArea.GrowthToolkit,
                        roleName: ['GrowthToolkit'],
                     },
                  },
               },
            ],
         },

         {
            path: 'report-poc',
            component: ReportPocComponent,
         },
      ],
   },

   {
      path: 'summer-splash-contest',
      canActivate: [AuthGuard],
      component: LeaderboardComponent,
      data: {
         areaName: 'Summer Splash Contest',
         breadcrumb: 'Summer Splash Contest',
         requiredRole: {
            application: ApplicationArea.Leaderboard,
            roleName: ['HospitalManager', 'RM', 'Leaderboard'],
         },
      },
   },

   {
      path: 'mentorship',
      canActivate: [AuthGuard],
      component: MentoringAgreementComponent,
      data: {
         areaName: 'Mentorship',
         breadcrumb: 'Mentorship',
         requiredRole: {
            application: ApplicationArea.Mentoring,
         },
      },
   },

   {
      path: 'messaging',
      component: MessagingAppComponent,
      canActivate: [AuthGuard],
      data: {
         areaName: 'Messaging',
         breadcrumb: 'Messaging',
         requiredRole: {
            application: ApplicationArea.Messaging,
         },
      },
   },

   {
      path: 'role-manager',
      component: RoleManagerComponent,
      canActivate: [AuthGuard],
      data: {
         areaName: 'Role Manager',
         breadcrumb: 'Role Manager',
         requiredRole: {
            application: ApplicationArea.RoleManager,
         },
      },
   },

   {
      path: 'leader-toolkit-user-management',
      component: UserManagementComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'User Management',
         breadcrumb: 'User Management',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },

   {
      path: 'leader-toolkit-ops-dashboard',
      component: OPSDashboardComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Operations Dashboard',
         breadcrumb: 'Operations Dashboard',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-toolkit-hospital-dashboard',
      component: HospitalDashboardComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Hospital Dashboard',
         breadcrumb: 'Hospital Dashboard',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
     {
      path: 'leader-toolkit-hospital-dashboard/:id',
      component: HospitalDashboardComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Hospital Dashboard',
         breadcrumb: 'Hospital Dashboard',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-tookit-hospitals/:hospitalid/ops-dashboard',
      component: HospitalOpsDashboardComponent,
      canActivate: [HmRestrictionGuard],
      data: {
         areaName: 'Hospital OPS Dashboard',
         breadcrumb: 'Hospital OPS Dashboard',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-toolkit-hospital-editor/:id',
      component: HospitalEditorComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Hospital Editor',
         breadcrumb: 'Hospital Editor',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-toolkit-goals',
      component: LeaderToolkitGoalsPage,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Leader Toolkit Goals',
         breadcrumb: 'Leader Toolkit Goals',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-toolkit-tasks',
      component: LeaderToolkitTasksPage,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Leader Toolkit Tasks',
         breadcrumb: 'Leader Toolkit Tasks',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
     {
      path: 'leader-upload-goals',
      component: UploadCsvComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Upload Goals',
         breadcrumb: 'Upload Goals',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-toolkit-scheduling',
      component: LeaderToolkitSchedulingPage,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Leader Toolkit Scheduling',
         breadcrumb: 'Leader Toolkit Scheduling',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-toolkit-dashboard',
      component: LeaderToolkitDashboardPage,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Leader Toolkit Dashboard',
         breadcrumb: 'Leader Toolkit Dashboard',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },

     {
      path: 'leader-goal-toolkit-details/:id',
      component: LeaderGoalToolkitDetailsComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Leader Toolkit Dashboard',
         breadcrumb: 'Leader Toolkit Dashboard',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-goal-details/:id',
      component: LeaderGoalToolkitDetailsComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Leader Toolkit Dashboard',
         breadcrumb: 'Leader Toolkit Dashboard',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
   {
      path: 'leader-toolkit-search',
      component: SearchResultsPageComponent,
      canActivate: [HmRestrictionGuard],
      // canActivate: [AuthGuard],
      data: {
         areaName: 'Search Results',
         breadcrumb: 'Search Results',
         requiredRole: {
            application: ApplicationArea.GrowthToolkit,
         },
      },
   },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
   exports: [RouterModule],
})
export class AppRoutingModule {}
